module.exports = "/assets/sign_marker_selected-22d84a72f5cc9722797cab54ee10eb9e.svg";